import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/reasing.svg',
})
export class ReasingIconComponent {}
